import { render, staticRenderFns } from "./URLImg.vue?vue&type=template&id=36f7859b"
import script from "./URLImg.vue?vue&type=script&lang=js"
export * from "./URLImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports